import loadingMutations from '@motionelements/core/src/store/mutations-mixins/loadingMutation.js';
import * as artistCategoriesApi from '@/api/artist/categories.js';

const state = {
  aiGenerators: [],
  selectedAiGenerator: null,
  loading: false,
  isLoaded: false,
};

const mutations = {
  setAiGenerators(state, list) {
    state.aiGenerators = list;
  },
  setSelectedAiGenerator(state, aiGenerator) {
    state.selectedAiGenerator = aiGenerator;
  },
  setIsLoaded(state, boolean) {
    state.isLoaded = boolean;
  },
};

const actions = {
  LIST_AI_GENERATORS({ commit, state }) {
    if (!state.isLoaded) {
      commit('setLoading', true);
      return artistCategoriesApi.listArtistCategories({ media_type: 'image_prompt', type: 'generator' })
        .then(({ data: { data: list } }) => {
          list = list.map(({ id, name }) => ({ id, name }));
          commit('setAiGenerators', list);
          commit('setIsLoaded', true);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          commit('setLoading', false);
        });
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations: { ...mutations, ...loadingMutations },
  actions,
};
